'use client';

import { c as _c } from "react/compiler-runtime";
import type { FilterItem, RangeSliderTick } from '@morpho-org/ui-v6/client';
import { MasterFilter } from '@morpho-org/ui-v6/client';
import { AVG_APY_DURATION_LABEL } from '@/constants/avgApy';
import { useMasterFilterTracking } from '@/lib/analytics/client/hooks/useMasterFilterTracking';
import type { MarketsMasterFilterState } from '../config/config';
import { DEFAULT_MARKETS_MASTER_FILTER_STATE, MARKETS_MASTER_FILTER_EXCLUDE_KEYS } from '../config/config';
const LLTV_TICKS: RangeSliderTick[] = [{
  value: 38.5,
  label: '38.5%'
}, {
  value: 62.5,
  label: '62.5%'
}, {
  value: 77.0,
  label: '77%'
}, {
  value: 86.0,
  label: '86%'
}, {
  value: 91.5,
  label: '91.5%'
}, {
  value: 94.5,
  label: '94.5%'
}, {
  value: 96.5,
  label: '96.5%'
}, {
  value: 98.0,
  label: '98%'
}];
interface MarketsMasterFilterProps {
  value: MarketsMasterFilterState;
  onChange: (value: MarketsMasterFilterState) => void;
  curatorItems: FilterItem<string>[];
}
export const MarketsMasterFilter = t0 => {
  const $ = _c(16);
  const {
    value,
    onChange,
    curatorItems
  } = t0;
  const tracking = useMasterFilterTracking("markets");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MasterFilter.Trigger label="Advanced" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== curatorItems) {
    t2 = <MasterFilter.AdvancedSelect name="curators" label="Trusted by" items={curatorItems} searchPlaceholder="Search curators..." />;
    $[1] = curatorItems;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MasterFilter.Range name="totalMarketSize" label="Total market size" unit="$" />;
    t4 = <MasterFilter.Range name="liquidity" label="Total liquidity" unit="$" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MasterFilter.Range name="rate" label={`Borrow rate (${AVG_APY_DURATION_LABEL.toLowerCase()})`} unit="%" />;
    t6 = <MasterFilter.RangeSlider name="lltv" label="LLTV" ticks={LLTV_TICKS} snapToTicks={true} />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2) {
    t7 = <MasterFilter.Content>{t2}{t3}{t4}{t5}{t6}</MasterFilter.Content>;
    $[7] = t2;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onChange || $[10] !== t7 || $[11] !== tracking.onFieldChange || $[12] !== tracking.onOpenChange || $[13] !== tracking.onReset || $[14] !== value) {
    t8 = <MasterFilter.Provider value={value} onChange={onChange} defaultValue={DEFAULT_MARKETS_MASTER_FILTER_STATE} excludeKeys={MARKETS_MASTER_FILTER_EXCLUDE_KEYS} onOpenChange={tracking.onOpenChange} onReset={tracking.onReset} onFieldChange={tracking.onFieldChange}>{t1}{t7}</MasterFilter.Provider>;
    $[9] = onChange;
    $[10] = t7;
    $[11] = tracking.onFieldChange;
    $[12] = tracking.onOpenChange;
    $[13] = tracking.onReset;
    $[14] = value;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};